import membershipAPI from '@/api/membership-tier-api'

const membership = {
    namespaced: true,
    state: {
        tierList: [],
    },
    getters: {
        tierList(state) {
            return state.tierList
        },
    },
    mutations: {
        SET_TIER_INFO(state, payload) {
            state.tierList = payload
        },
    },
    actions: {
        async fetchMembershipTierList({ commit }) {
            try {
                const responseTierList = await membershipAPI.fetchMembershipTierList()
                if (responseTierList.status === 200) {
                    await commit('SET_TIER_INFO', responseTierList.data.data)
                } else {
                    throw 'set tierList empty'
                }
            } catch (error) {
                await commit('SET_TIER_INFO', [])
            }
        },
    },
}

export default membership
